import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "popup__container" }
const _hoisted_3 = { class: "popup__content" }
const _hoisted_4 = { class: "popup__header" }
const _hoisted_5 = { class: "h2-like" }
const _hoisted_6 = { class: "popup__block" }
const _hoisted_7 = { class: "form__submit" }
const _hoisted_8 = { class: "btn btn--fullscreen" }

import { computed, onMounted, ref } from "vue"
import { useI18n } from "vue3-i18n"
import { notifyError } from "@/notify"
import { Status } from "@/validation"
import FormInput from "@/components/forms/FormInput.vue"
import { Link } from "@/types";
import { Quill, QuillEditor } from "@vueup/vue-quill";
import FormTooltip from "@/components/forms/FormTooltip.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'FormTextEditorLinkPopup',
  props: {
    name: {},
    quillEditor: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line
const emit = __emit

const { t } = useI18n()

const selection = ref<any>(null)
const selectionHTML = ref<any>(null)
const selectionContainsImage = computed(() => selectionHTML.value?.includes("<img"))
const selectedText = ref<any>(null)
const link = ref<Link>({
  label: "",
  url: "",
})

//Functions ======================================
onMounted( () => {
  //keep quill editor in memory 
  const quill = props.quillEditor.getQuill();
  
  if(quill) {
    //if the popup is open, init label as selection if applicable.
    selection.value = quill.getSelection(true);
    selectionHTML.value = getSelectionHtml(quill.getContents(selection.value.index, selection.value.length));
    selectedText.value = quill.getText(selection.value.index, selection.value.length);

    if (selectedText.value) {
      link.value.label = selectedText.value;
    }
  }
});

function getSelectionHtml(selectedContent:any) {
  let tempContainer = document.createElement('div')
  let tempQuill = new Quill(tempContainer);
  
  tempQuill.setContents(selectedContent);
  return tempContainer.querySelector('.ql-editor')?.innerHTML;
}

function handleSubmit() {
  formInputs.value.forEach((x: typeof FormInput) => x?.validateInput())
  
  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  addLinkToQuill();
}

function addLinkToQuill() {
  const quill = props.quillEditor.getQuill();

  if(quill){
    const url = !/^https?:\/\//i.test(link.value.url) ? "https://" + link.value.url.replace("http://", "") : link.value.url;
    const content = selectionContainsImage.value ? selectionHTML.value : link.value.label;
    
    const linkTag = `<a href="${url}">${content}</a>`
    
    selection.value = quill.getSelection(true);
    
    //if selected, delete the old text
    if (selectionContainsImage.value) quill.deleteText(selection.value.index, 1);
    if (selectedText.value) quill.deleteText(selection.value.index, selectedText.value.length);
    
    //then, add the new tag
    quill.clipboard.dangerouslyPasteHTML(selection.value.index, linkTag, 'user');

    if (selectionContainsImage.value) quill.setSelection(selection.value.index, 1);
    if (link.value.label) quill.setSelection(selection.value.index, link.value.label.length);

    //then, close popup
    closePopup();
  }
}

function closePopup() {
  emit("closePopup");
}

//Validation =================================
const formInputs = ref<(typeof FormInput)[]>([])
const inputValidationStatuses: any = {}

function addFormInputRef(ref: typeof FormInput) {
  if (!formInputs.value.includes(ref))
    formInputs.value.push(ref)
}

async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "popup popup--visible",
    novalidate: "",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _createElementVNode("div", {
      class: "popup__bg",
      onClick: closePopup
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("textEditorLinkPopup.addLink")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!selectionContainsImage.value)
            ? (_openBlock(), _createBlock(FormInput, {
                key: 0,
                modelValue: link.value.label,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((link.value.label) = $event)),
                ref: addFormInputRef,
                label: _unref(t)('textEditorLinkPopup.label'),
                name: `link-label-${_ctx.name}`,
                type: "text",
                onValidated: handleValidation
              }, null, 8, ["modelValue", "label", "name"]))
            : (_openBlock(), _createBlock(FormTooltip, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)("textEditorLinkPopup.image")), 1)
                ]),
                _: 1
              })),
          _createVNode(FormInput, {
            modelValue: link.value.url,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((link.value.url) = $event)),
            ref: addFormInputRef,
            label: _unref(t)('textEditorLinkPopup.url'),
            name: `link-url-${_ctx.name}`,
            type: "url",
            onValidated: handleValidation
          }, null, 8, ["modelValue", "label", "name"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(t)('global.add')), 1),
            _createElementVNode("button", {
              class: "btn btn--fullscreen btn--red",
              type: "button",
              onClick: closePopup
            }, _toDisplayString(_unref(t)('global.cancel')), 1)
          ])
        ])
      ])
    ])
  ], 40, _hoisted_1))
}
}

})